// Onboarding step content - single source of truth so the wizard, progress
// bar, and analytics labels stay in sync.

export const ONBOARDING_GOALS = [
  { id: "first_customers", label: "Get my first paying customers", desc: "I'm pre-launch or just starting." },
  { id: "more_leads", label: "Generate more leads consistently", desc: "I have customers - I want a reliable pipeline." },
  { id: "scale_brand", label: "Scale my brand and content", desc: "I'm growing - I need to look bigger and ship faster." },
  { id: "save_time", label: "Save time on marketing tasks", desc: "I'm doing it all alone - I need leverage." },
];

export const BUSINESS_TYPES = [
  "Local service business",
  "E-commerce / DTC",
  "Agency / Studio",
  "SaaS / App",
  "Creator / Coach",
  "Restaurant / Hospitality",
  "Other",
];

export const VOICE_TRAITS = [
  { id: "warm", label: "Warm & friendly" },
  { id: "expert", label: "Expert & authoritative" },
  { id: "playful", label: "Playful & witty" },
  { id: "luxe", label: "Luxe & polished" },
  { id: "bold", label: "Bold & direct" },
  { id: "calm", label: "Calm & reassuring" },
];

export const CHANNELS = [
  { id: "instagram", label: "Instagram" },
  { id: "linkedin", label: "LinkedIn" },
  { id: "tiktok", label: "TikTok" },
  { id: "email", label: "Email newsletter" },
  { id: "blog", label: "Blog / SEO" },
  { id: "google", label: "Google Business" },
  { id: "x", label: "X / Twitter" },
  { id: "youtube", label: "YouTube" },
];

export const STEPS = [
  { id: "goal", label: "Your goal", num: "01" },
  { id: "business", label: "Your business", num: "02" },
  { id: "voice", label: "Your voice", num: "03" },
  { id: "channels", label: "Your channels", num: "04" },
];
